const homeSchema = {
  images: [],
  video: null,
};

export default homeSchema;
